import axios from 'axios';

/**
 * Envia dados para endpoint externo
 */
export async function handleHttpEndpoint(url, formData) {
  try{
    const { data } = await axios.post(url, formData);
    console.log(`✅ Dados enviados para ${url}`);
    return data
  }catch(e){
    throw e
  }
}
